import { Title } from './Title.styles'

export default Title
